// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__FZDwR","small-icon":"styles_small-icon__1n2ak"};